import {VersioningService} from 'app/fragment/versioning/versioning.service';
import {VersionTag} from 'app/interfaces';
import {UUID} from 'app/utils/uuid';
import {ReferenceSummaryType} from './reference-summary-type';

export class ReferenceSummaryRow {
  public sourceDocumentId: UUID;
  public targetDocumentId: UUID;
  public referenceSummaryType: ReferenceSummaryType;
  public documentCode: string;
  public documentTitle: string;
  public targetVersionIsLive: boolean;
  public lastPublishedVersionTag: VersionTag;
  public liveNumberOfReferences: number;
  public liveNumberOfInvalidReferences: number;
  public liveInvalidDocumentReferenceIds: UUID[];
  public lastPublishedNumberOfReferences: number;
  public lastPublishedNumberOfInvalidReferences: number;
  public lastPublishedInvalidDocumentReferenceIds: UUID[];
  public rowExpanded: boolean;

  constructor(
    sourceDocumentId: UUID,
    targetDocumentId: UUID,
    referenceSummaryType: ReferenceSummaryType,
    documentCode: string,
    documentTitle: string,
    targetVersionIsLive: boolean,
    lastPublishedVersionTag: VersionTag,
    liveNumberOfReferences: number,
    liveNumberOfInvalidReferences: number,
    liveInvalidDocumentReferenceIds: UUID[],
    lastPublishedNumberOfReferences: number,
    lastPublishedNumberOfInvalidReferences: number,
    lastPublishedInvalidDocumentReferenceIds: UUID[]
  ) {
    this.sourceDocumentId = sourceDocumentId;
    this.targetDocumentId = targetDocumentId;
    this.referenceSummaryType = referenceSummaryType;
    this.documentCode = documentCode;
    this.documentTitle = documentTitle;
    this.targetVersionIsLive = targetVersionIsLive;
    this.lastPublishedVersionTag = lastPublishedVersionTag;
    this.liveNumberOfReferences = liveNumberOfReferences === undefined ? 0 : liveNumberOfReferences;
    this.liveNumberOfInvalidReferences =
      liveNumberOfInvalidReferences === undefined ? 0 : liveNumberOfInvalidReferences;
    this.liveInvalidDocumentReferenceIds = liveInvalidDocumentReferenceIds;
    this.lastPublishedNumberOfReferences = lastPublishedNumberOfReferences;
    this.lastPublishedNumberOfInvalidReferences = lastPublishedNumberOfInvalidReferences;
    this.lastPublishedInvalidDocumentReferenceIds = lastPublishedInvalidDocumentReferenceIds;
    this.rowExpanded = false;
  }

  public static deserialise(json: any): ReferenceSummaryRow {
    return new ReferenceSummaryRow(
      UUID.orThrow(json.sourceDocumentId),
      UUID.orThrow(json.targetDocumentId),
      json.referenceSummaryType,
      json.documentCode,
      json.documentTitle,
      json.isTargetLive,
      !!json.lastPublishedVersionTag ? VersioningService.deserialiseVersionTag(json.lastPublishedVersionTag) : null,
      json.liveReferenceInformation.totalCount,
      json.liveReferenceInformation.invalidCount,
      json.liveReferenceInformation.invalidDocumentReferenceIds.map((id: any) => UUID.orThrow(id)),
      json.lastPublishedReferenceInformation?.totalCount ?? null,
      json.lastPublishedReferenceInformation?.invalidCount ?? null,
      json.lastPublishedReferenceInformation?.invalidDocumentReferenceIds.map((id: any) => UUID.orThrow(id)) ?? null
    );
  }
}
